// ============================================================
// BOLD BRASILEIRO — Nav hamburger toggle
// ============================================================

(function () {
    'use strict';

    const header = document.getElementById('header');
    const toggle = document.getElementById('navHamburger');
    const menu   = document.getElementById('navMenu');

    if (!header || !toggle || !menu) return;

    const open = () => {
        toggle.setAttribute('aria-expanded', 'true');
        header.classList.add('is-open');
    };

    const close = () => {
        toggle.setAttribute('aria-expanded', 'false');
        header.classList.remove('is-open');
    };

    toggle.addEventListener('click', () => {
        if (toggle.getAttribute('aria-expanded') === 'true') {
            close();
        } else {
            open();
        }
    });

    // Smooth scroll + fechar menu
    menu.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener('click', (e) => {
            const id = link.getAttribute('href');
            if (!id || id === '#') return;
            const target = document.querySelector(id);
            if (!target) return;

            e.preventDefault();
            close();

            const headerH = header.offsetHeight;
            const y = target.getBoundingClientRect().top + window.scrollY - headerH + 1;
            window.scrollTo({ top: y, behavior: 'smooth' });
        });
    });
})();
